export default () => {
    return window.countries.sort((a, b) => a.label.localeCompare(b.label))
};
